// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  background-color: rgb(233, 226, 214);
  position: relative;
}

.login-content-container {
  display: flex;
  height: 116vh;
  background-repeat: no-repeat;
  justify-content: end;
  padding-top: 7.8em;
}

.inner-login-container {
  height: 100%;
  background-color: #fff;
  width: 50%;
  border-radius: 50px 0px 0px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8em 8em;
}

#login-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: #5e4c88;
  font-weight: 700;
  font-size: 2.1rem;
}

#login-header span {
  color: #bc9892;
  font-weight: 400;
}

#login-header img {
  width: 95px;
  height: 95px;
}

.inner-login-container h4 {
  padding-top: 4em;
  color: #7c766b;
  font-weight: 700;
  font-size: 1.6rem;
}

form {
  padding: 1em 2em 4em 2em;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  font-weight: 700;
  color: #411f53;
  padding: 0.7em;
}

.form-group label {
  font-size: 1.2rem;
}

.form-group input {
  padding: 1.3em 2.6em 1.3em 1em;
  width: 55vh;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #411f53;
  color: #411f53;
  outline: none;
}

.password-input-container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.show-password-icon {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  margin-left: 1em;
}

.form-group-row {
  display: flex;
  justify-content: center;
  padding: 0.7em 3.5em;
  color: #eb450b;
}

.checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
}

.checkbox label {
  font-weight: 500;
}

.form-group-row a {
  color: #eb450b;
}

.form-group-button {
  padding-top: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2em;
}

.group-button-login {
  padding: 1em;
}

.group-button-login button {
  background-color: #522a68;
  padding: 0.7em 4.2em;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #522a68;
  color: #fff;
  font-size: 1.1rem;
}

.group-button-login button:hover {
  background-color: #fff;
  transition: 0.2s ease;
  color: #522a68;
  font-weight: 600;
}

.group-button-register {
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #eb450b;
  font-weight: 600;
}

.group-button-register a {
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #522a68;
  color: #522a68;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 0.7em 4.2em;
}

.group-button-register a:hover {
  color: #fff;
  background-color: #522a68;
  transition: 0.2s ease;
}

/******************************************************* register form *************************************************/
/******************************************************* register form *************************************************/
/******************************************************* register form *************************************************/
/******************************************************* register form *************************************************/
/******************************************************* register form *************************************************/
.regis-container {
  position: relative;
  background-color: rgb(233, 226, 214);
}

.regis-content-container {
  display: flex;
  height: 135vh;
  background-repeat: no-repeat;
  justify-content: end;
  padding-top: 7.8em;
}

.inner-regis-container {
  height: 100%;
  background-color: #fff;
  width: 50%;
  border-radius: 50px 0px 0px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8em 8em;
}

.inner-regis-container h4 {
  padding-top: 2em;
  color: #7c766b;
  font-weight: 700;
  font-size: 1.4rem;
}

#register-button {
  background-color: #522a68;
  padding: 0.7em 4.2em;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #522a68;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
}

#register-button:hover {
  background-color: #fff;
  color: #522a68;
}

.wrong-credential-txt {
  visibility: hidden;
  color: #ff0000;
}

.same-email-indicators {
  display: none;
  color: #ff0000;
}

.char-indicator {
  display: none;
  color: #ff0000;
  font-size: 1rem;
  font-weight: 600;
}

.char-indicator span {
  font-style: italic;
  font-size: 0.8rem;
  color: #000;
}

.indicator-password {
  height: 10px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: none;
}

.indicator-password span {
  position: relative;
  height: 100%;
  width: 100%;
  background: lightgrey;
  border-radius: 5px;
}

.indicator-password span:nth-child(2) {
  margin: 0 3px;
}

.indicator-password span.active:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}

.indicator-password span.weak:before {
  background-color: #ff4757;
}
.indicator-password span.medium:before {
  background-color: orange;
}

.indicator-password span.strong:before {
  background-color: #23ad5c;
}

.txt-indicator-password {
  font-size: 1rem;
  font-weight: 500;
  display: none;
  margin-bottom: -10px;
  padding-bottom: 1em;
}

.txt-indicator-password.weak {
  color: #ff4757;
}

.txt-indicator-password.medium {
  color: orange;
}

.txt-indicator-password.strong {
  color: #23ad5c;
}

/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
/* ADDITIONAL */
input[type="checkbox"] {
  /* Menghilangkan default browser styles */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 14px;
  height: 13px;
  /* Gaya border dan background ketika tidak dicentang */
  border: 2px solid #eb450b;
  background-color: #fff;
  /* Posisi relative untuk styling pseudo-elements */
  position: relative;
  /* Penggunaan pseudo-element untuk styling checkmark */
}
/* Gaya tampilan checkbox ketika dicentang */
input[type="checkbox"]:checked {
  background-color: #eb450b; /* Ganti dengan warna yang diinginkan */
}
/* Gaya tampilan checkmark */
input[type="checkbox"]::before {
  content: "\\2713"; /* Karakter unicode untuk checkmark */
  font-size: 10px;
  color: #fff; /* Ganti dengan warna yang diinginkan */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
}
/* Gaya tampilan checkmark ketika dicentang */
input[type="checkbox"]:checked::before {
  display: block;
}

/*Forgot Password*/
.forgot-password-container {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.forgot-password-container .forgot-password-text {
  padding-bottom: 1.5em;
}

.forgot-password-text h1 {
  font-size: 3.5rem;
  font-weight: 700;
  color: #522a68;
}

.forgot-password-text p {
  font-size: 1.1rem;
  font-weight: 500;
  color: #7c766b;
}

.forgot-password-content {
  padding: 11em 4.2em 1em 4.2em;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/styles/auth.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wHAAwH;AACxH,wHAAwH;AACxH,wHAAwH;AACxH,wHAAwH;AACxH,wHAAwH;AACxH;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf,eAAe;AACf;EACE,yCAAyC;EACzC,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sDAAsD;EACtD,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;EAClD,kBAAkB;EAClB,sDAAsD;AACxD;AACA,4CAA4C;AAC5C;EACE,yBAAyB,EAAE,uCAAuC;AACpE;AACA,4BAA4B;AAC5B;EACE,gBAAgB,EAAE,qCAAqC;EACvD,eAAe;EACf,WAAW,EAAE,uCAAuC;EACpD,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;AACA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".login-container {\n  background-color: rgb(233, 226, 214);\n  position: relative;\n}\n\n.login-content-container {\n  display: flex;\n  height: 116vh;\n  background-repeat: no-repeat;\n  justify-content: end;\n  padding-top: 7.8em;\n}\n\n.inner-login-container {\n  height: 100%;\n  background-color: #fff;\n  width: 50%;\n  border-radius: 50px 0px 0px 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8em 8em;\n}\n\n#login-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-decoration: none;\n  color: #5e4c88;\n  font-weight: 700;\n  font-size: 2.1rem;\n}\n\n#login-header span {\n  color: #bc9892;\n  font-weight: 400;\n}\n\n#login-header img {\n  width: 95px;\n  height: 95px;\n}\n\n.inner-login-container h4 {\n  padding-top: 4em;\n  color: #7c766b;\n  font-weight: 700;\n  font-size: 1.6rem;\n}\n\nform {\n  padding: 1em 2em 4em 2em;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2em;\n  font-weight: 700;\n  color: #411f53;\n  padding: 0.7em;\n}\n\n.form-group label {\n  font-size: 1.2rem;\n}\n\n.form-group input {\n  padding: 1.3em 2.6em 1.3em 1em;\n  width: 55vh;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 10px 10px 10px 10px;\n  border: 1px solid #411f53;\n  color: #411f53;\n  outline: none;\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.show-password-icon {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 20px;\n  user-select: none;\n  margin-left: 1em;\n}\n\n.form-group-row {\n  display: flex;\n  justify-content: center;\n  padding: 0.7em 3.5em;\n  color: #eb450b;\n}\n\n.checkbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3em;\n}\n\n.checkbox label {\n  font-weight: 500;\n}\n\n.form-group-row a {\n  color: #eb450b;\n}\n\n.form-group-button {\n  padding-top: 1.5em;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2em;\n}\n\n.group-button-login {\n  padding: 1em;\n}\n\n.group-button-login button {\n  background-color: #522a68;\n  padding: 0.7em 4.2em;\n  border-radius: 10px 10px 10px 10px;\n  border: 1px solid #522a68;\n  color: #fff;\n  font-size: 1.1rem;\n}\n\n.group-button-login button:hover {\n  background-color: #fff;\n  transition: 0.2s ease;\n  color: #522a68;\n  font-weight: 600;\n}\n\n.group-button-register {\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #eb450b;\n  font-weight: 600;\n}\n\n.group-button-register a {\n  border-radius: 10px 10px 10px 10px;\n  border: 1px solid #522a68;\n  color: #522a68;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 0.7em 4.2em;\n}\n\n.group-button-register a:hover {\n  color: #fff;\n  background-color: #522a68;\n  transition: 0.2s ease;\n}\n\n/******************************************************* register form *************************************************/\n/******************************************************* register form *************************************************/\n/******************************************************* register form *************************************************/\n/******************************************************* register form *************************************************/\n/******************************************************* register form *************************************************/\n.regis-container {\n  position: relative;\n  background-color: rgb(233, 226, 214);\n}\n\n.regis-content-container {\n  display: flex;\n  height: 135vh;\n  background-repeat: no-repeat;\n  justify-content: end;\n  padding-top: 7.8em;\n}\n\n.inner-regis-container {\n  height: 100%;\n  background-color: #fff;\n  width: 50%;\n  border-radius: 50px 0px 0px 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8em 8em;\n}\n\n.inner-regis-container h4 {\n  padding-top: 2em;\n  color: #7c766b;\n  font-weight: 700;\n  font-size: 1.4rem;\n}\n\n#register-button {\n  background-color: #522a68;\n  padding: 0.7em 4.2em;\n  border-radius: 10px 10px 10px 10px;\n  border: 1px solid #522a68;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n#register-button:hover {\n  background-color: #fff;\n  color: #522a68;\n}\n\n.wrong-credential-txt {\n  visibility: hidden;\n  color: #ff0000;\n}\n\n.same-email-indicators {\n  display: none;\n  color: #ff0000;\n}\n\n.char-indicator {\n  display: none;\n  color: #ff0000;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.char-indicator span {\n  font-style: italic;\n  font-size: 0.8rem;\n  color: #000;\n}\n\n.indicator-password {\n  height: 10px;\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  display: none;\n}\n\n.indicator-password span {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  background: lightgrey;\n  border-radius: 5px;\n}\n\n.indicator-password span:nth-child(2) {\n  margin: 0 3px;\n}\n\n.indicator-password span.active:before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.indicator-password span.weak:before {\n  background-color: #ff4757;\n}\n.indicator-password span.medium:before {\n  background-color: orange;\n}\n\n.indicator-password span.strong:before {\n  background-color: #23ad5c;\n}\n\n.txt-indicator-password {\n  font-size: 1rem;\n  font-weight: 500;\n  display: none;\n  margin-bottom: -10px;\n  padding-bottom: 1em;\n}\n\n.txt-indicator-password.weak {\n  color: #ff4757;\n}\n\n.txt-indicator-password.medium {\n  color: orange;\n}\n\n.txt-indicator-password.strong {\n  color: #23ad5c;\n}\n\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\n/* ADDITIONAL */\ninput[type=\"checkbox\"] {\n  /* Menghilangkan default browser styles */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 13px;\n  /* Gaya border dan background ketika tidak dicentang */\n  border: 2px solid #eb450b;\n  background-color: #fff;\n  /* Posisi relative untuk styling pseudo-elements */\n  position: relative;\n  /* Penggunaan pseudo-element untuk styling checkmark */\n}\n/* Gaya tampilan checkbox ketika dicentang */\ninput[type=\"checkbox\"]:checked {\n  background-color: #eb450b; /* Ganti dengan warna yang diinginkan */\n}\n/* Gaya tampilan checkmark */\ninput[type=\"checkbox\"]::before {\n  content: \"\\2713\"; /* Karakter unicode untuk checkmark */\n  font-size: 10px;\n  color: #fff; /* Ganti dengan warna yang diinginkan */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: none;\n}\n/* Gaya tampilan checkmark ketika dicentang */\ninput[type=\"checkbox\"]:checked::before {\n  display: block;\n}\n\n/*Forgot Password*/\n.forgot-password-container {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.forgot-password-container .forgot-password-text {\n  padding-bottom: 1.5em;\n}\n\n.forgot-password-text h1 {\n  font-size: 3.5rem;\n  font-weight: 700;\n  color: #522a68;\n}\n\n.forgot-password-text p {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #7c766b;\n}\n\n.forgot-password-content {\n  padding: 11em 4.2em 1em 4.2em;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
